module.exports = __webpack_public_path__ + "static/media/story_thumb.59d41206.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/story_thumb.png
// module id = 175
// module chunks = 0